import { render, staticRenderFns } from "./DecisionEditor.vue?vue&type=template&id=bd3cb152&scoped=true&"
import script from "./DecisionEditor.vue?vue&type=script&lang=ts&"
export * from "./DecisionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionEditor.vue?vue&type=style&index=0&id=bd3cb152&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3cb152",
  null
  
)

export default component.exports